export default __webpack_public_path__ + "static/media/ic_iser.ce27daaa.svg";